import { render, staticRenderFns } from "./TargetsBlock.vue?vue&type=template&id=8910d41e&"
import script from "./TargetsBlock.vue?vue&type=script&lang=ts&"
export * from "./TargetsBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports